//@flow
import React from 'react';
import { FormattedMessage } from 'react-intl';
import { createFragmentContainer, graphql } from 'react-relay';
import getter from 'dibs-object-getter';
import { tradeLoyaltyStatuses } from '../constants';

import { Button } from 'dibs-elements/exports/Button';

import styles from './EnrollCta.scss';

import type { EnrollCta_tradeFirm as tradeFirmType } from './__generated__/EnrollCta_tradeFirm.graphql';

type EnrollCtaProps = {
    enrollmentPage?: boolean,
    tradeFirm: tradeFirmType,
};

const { ELIGIBLE, NOT_ELIGIBLE } = tradeLoyaltyStatuses;

const EnrollCta = (props: EnrollCtaProps) => {
    if (props.enrollmentPage) {
        return null;
    }

    const status = getter(props)
        .at('tradeFirm')
        .at('loyalty')
        .value('status');

    if (status !== ELIGIBLE && status !== NOT_ELIGIBLE) {
        return null;
    }

    return (
        <div className={`primary-viewport-width ${styles.background}`}>
            <div className={styles.wrapper}>
                <div className={styles.aboutSectionHeader}>
                    <FormattedMessage
                        id="loyalty.EnrollCta.header"
                        defaultMessage="Start Earning Cashback"
                    />
                </div>
                <Button
                    type="primary"
                    size="medium"
                    href="/trade/loyalty/enrollment/"
                    className={styles.button}
                    dataTn="trade-loyalty-enrollment-cta"
                >
                    <FormattedMessage
                        id="loyaltyModules.EnrollCta.cta"
                        defaultMessage="Enroll Now"
                    />
                </Button>
            </div>
        </div>
    );
};

export { EnrollCta };

export default createFragmentContainer(
    EnrollCta,
    graphql`
        fragment EnrollCta_tradeFirm on TradeFirmType {
            loyalty {
                status
            }
        }
    `
);
